export default __webpack_public_path__ + "static/media/info.0c0bf0ae.svg";